import * as Actions from '../actionsgazeta';

const initialState = [];

const programas = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_PROGRAMAS_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_PROGRAMAS_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default programas;
